import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import NoUsersWithAccess from '../../../../assets/images/ill_empty_access_sharing_operators.svg';
import { Input } from '@progress/kendo-react-inputs';
import { ic_close_small_black as BlackCloseIcon } from 'app/widgets/SVGs';
import SearchIcon from 'assets/images/ic_search.svg';
// import SharedWithRow from './SharedWithRow';
import { removeEmojis } from 'utils/general';
import { useIsMobile } from 'app/hooks/useIsMobile';
import useGetEquipmentData from 'app/hooks/useGetEquipmentData';
import SharedWithRow from './SharedWithRow';
import { filterSharedWith } from 'utils/searchFilter';

function SharedWith() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const { equipments, sharedUsers } = useGetEquipmentData();
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [isExpanded, setIsExpanded] = React.useState(false);

  const filteredSharedUsers = useMemo(() => {
    if (!sharedUsers) {
      return [];
    }
    return filterSharedWith(sharedUsers, searchValue);
  }, [sharedUsers, searchValue]);

  return (
    <div className="access-sharing-subcontainer">
      <div className="access-sharing-subcontainer-header">
        {equipments?.length == 0 ? (
          <h3>{t('shared_with')}</h3>
        ) : (
          <div className="access-sharing-subcontainer-header-content no-filters">
            <h3>{t('shared_with')}</h3>
            <div className="site-search open">
              <span className="search-icon">
                <img alt="Search" src={SearchIcon}></img>
              </span>
              <div className="search-input">
                <Input
                  name="shared_with_users_search"
                  value={searchValue}
                  placeholder={t('shared_with_search_placeholder')}
                  onChange={newValue => {
                    setSearchValue(removeEmojis(newValue.value));
                  }}
                  onClick={() => setIsExpanded(!isExpanded)}
                />
                {searchValue && (
                  <span
                    className="search-icon-close"
                    onClick={() => {
                      setSearchValue('');
                    }}
                  >
                    <BlackCloseIcon />
                  </span>
                )}
              </div>
            </div>
            <div></div>
          </div>
        )}
      </div>
      <div className="access-sharing-subcontainer-body">
        {filteredSharedUsers?.length == 0 ? (
          <div className="access-sharing-subcontainer-body-empty">
            <div className="access-sharing-body-picture">
              <img src={NoUsersWithAccess}></img>
            </div>
            <div className="access-sharing-body-text">
              <h4>{t('shared_with_no_users_title')}</h4>
              <p>{t('shared_with_no_users_text')}</p>
            </div>
          </div>
        ) : (
          <div className="access-sharing-subcontainer-body-table">
            <div className="access-sharing-subcontainer-body-table-header shared-with">
              <div>{t('user')}</div>
              <div>{t('access_to')}</div>
              <div></div>
              <div></div>
            </div>
            <div className="access-sharing-subcontainer-body-table-body shared-with">
              {filteredSharedUsers?.map(user => {
                return (
                  <SharedWithRow
                    user={user}
                    isMobile={isMobile}
                    key={user.email}
                  />
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SharedWith;
